export const BoletoMensagens = {
  ALTERACAO_VENCIMENTO_NAO_PERMITIDA: 'Alteração de vencimento não permitida.',
  PAGAMENTO_SUCESSO_BOLETO: 'Em breve o cliente receberá um e-mail com o boleto.'
}

export const BoletoMensagensCliente = {
  PAGAMENTO_SUCESSO_BOLETO: 'Em breve você receberá um e-mail com o boleto.',
  PAGAMENTO_SUCESSO_BOLETO_MULTIPLO: 'Em breve você receberá um e-mail com os boletos.'
}
